import { amplifyProxy } from '@/services/directApi'

export default {
  namespaced: true,
  state: {
    properties: '',
    loading: false,
    error: null
  },
  mutations: {
    SET_PROPERTIES(state, data) {
      state.properties = data
    },
    SET_LOADING(state, value) {
      state.loading = value
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },
  actions: {
    async getPropertiesCount({ commit, dispatch }) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)

      try {
        const [
          managed,
          ownerless,
          collected,
          tenantless,
          unmanaged,
          newTenancies,
          historicTenancies
        ] = await Promise.all([
          dispatch('getPropertiesManaged'),
          dispatch('getPropertiesOwnerless'),
          dispatch('getPropertiesRentcollected'),
          dispatch('getPropertiesTenantless'),
          dispatch('getPropertiesUnmanaged'),
          dispatch('getPropertiesNewTenancies'),
          dispatch('getPropertiesHistoricTenancies')
        ])

        
        const propertyData = {
          managed: managed.data,
          ownerless: ownerless.data,
          collected: collected.data,
          tenantless: tenantless.data,
          unmanaged: unmanaged.data,
          newTenancies: newTenancies.data,
          historicTenancies: historicTenancies.data
        }

        commit('SET_PROPERTIES', propertyData)
        return propertyData
      } catch (error) {
        commit('SET_ERROR', error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async getPropertiesManaged({ rootState }) {
      const endpoint = `/${rootState.user.ClientName}/properties/managed/count`
      const options = {
        headers: {
          token: rootState.user.LoginToken,

        },
        queryStringParameters: {
          branchID: rootState.branchID
        }
      }

      return amplifyProxy.get(endpoint, options)
    },

    async getPropertiesOwnerless({ rootState }) {
      const endpoint = `/${rootState.user.ClientName}/properties/ownerless/count`
      const options = {
        headers: {
          token: rootState.user.LoginToken,

        },
        queryStringParameters: {
          branchID: rootState.branchID
        }
      }

      return amplifyProxy.get(endpoint, options)
    },

    async getPropertiesRentcollected({ rootState }) {
      const endpoint = `/${rootState.user.ClientName}/properties/rentcollect/count`
      const options = {
        headers: {
          token: rootState.user.LoginToken,

        },
        queryStringParameters: {
          branchID: rootState.branchID
        }
      }

      return amplifyProxy.get(endpoint, options)
    },

    async getPropertiesTenantless({ rootState }) {
      const endpoint = `/${rootState.user.ClientName}/properties/tenantless/count`
      const options = {
        headers: {
          token: rootState.user.LoginToken,

        },
        queryStringParameters: {
          branchID: rootState.branchID
        }
      }

      return amplifyProxy.get(endpoint, options)
    },

    async getPropertiesUnmanaged({ rootState }) {
      const endpoint = `/${rootState.user.ClientName}/properties/unmanaged/count`
      const options = {
        headers: {
          token: rootState.user.LoginToken,

        },
        queryStringParameters: {
          branchID: rootState.branchID
        }
      }

      return amplifyProxy.get(endpoint, options)
    },

    async getPropertiesNewTenancies({ rootState }) {
      const endpoint = `/${rootState.user.ClientName}/properties/newtenancies/count`
      const options = {
        headers: {
          token: rootState.user.LoginToken,

        },
        queryStringParameters: {
          branchID: rootState.branchID
        }
      }

      return amplifyProxy.get(endpoint, options)
    },

    async getPropertiesHistoricTenancies({ rootState }) {
      const endpoint = `/${rootState.user.ClientName}/properties/historictenancies/count`
      const options = {
        headers: {
          token: rootState.user.LoginToken,

        },
        queryStringParameters: {
          branchID: rootState.branchID
        }
      }

      return amplifyProxy.get(endpoint, options)
    }
  }
}